(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('evvela-recommendations')) return;
    customElements.define('evvela-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController || this.dataset.loaded === 'true' || !this.dataset.url) return;
        this.abortController = new AbortController();
        const showFallback = () => {
          const fallback = this.querySelector('[data-recommendation-fallback]');
          if (!fallback?.content?.childElementCount) return false;
          this.replaceChildren(fallback.content.cloneNode(true));
          this.dataset.loaded = 'true';
          delete this.dataset.url;
          return true;
        };
        fetch(this.dataset.url, { signal: this.abortController.signal })
          .then((response) => {
            if (!response.ok) throw new Error('Recommendation request failed');
            return response.text();
          })
          .then((html) => {
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const rendered = documentFragment.querySelector('evvela-recommendations[data-loaded="true"]');
            if (rendered?.querySelector('.product-recommendations__grid')) {
              this.innerHTML = rendered.innerHTML;
              this.dataset.loaded = 'true';
              delete this.dataset.url;
            } else {
              if (!showFallback()) this.remove();
            }
          })
          .catch((error) => {
            if (error.name !== 'AbortError' && !showFallback()) this.remove();
          });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
